module.exports = __webpack_public_path__ + "img/yoga3.aa809672.jpg";